/** Display names for codes whose label isn't the code with its prefix removed. */
const KEY_NAMES: Readonly<Partial<Record<string, string>>> = {
  Escape: 'Esc',
  ShiftLeft: 'Shift',
  ShiftRight: 'Shift',
  ControlLeft: 'Ctrl',
  ControlRight: 'Ctrl',
  AltLeft: 'Alt',
  AltRight: 'Alt',
  MetaLeft: 'Meta',
  MetaRight: 'Meta',
  ArrowUp: '↑',
  ArrowDown: '↓',
  ArrowLeft: '←',
  ArrowRight: '→',
  MouseLeft: 'LMB',
  MouseRight: 'RMB',
  MouseMiddle: 'MMB',
}

/** `KeyE` → `E`, `Digit1` → `1`, `ShiftLeft` → `Shift`, `MouseLeft` → `LMB`. */
export function formatKeyCode(code: string): string {
  const named = KEY_NAMES[code]
  if (named !== undefined) return named
  const match = /^(?:Key|Digit)(.+)$/.exec(code)
  if (match?.[1] !== undefined) return match[1]
  return code.replace(/^Numpad/, 'Num ')
}
